module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/pretty-check/color-checkbox-solid/color-checkbox-solid.component.scss
// module id = ./src/app/features/pretty-check/color-checkbox-solid/color-checkbox-solid.component.scss
// module chunks = main